"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const interfaces_1 = require("@buildcore/interfaces");
const GetByIdGroupedLive_1 = require("./GetByIdGroupedLive");
class GetTokenAvgPriceGroupedLiveClass extends GetByIdGroupedLive_1.GetByIdGroupedLiveClass {
    constructor() {
        super(...arguments);
        this.createUrl = () => Object.values(this.groupRequests()).map((r) => {
            const params = { token: r.map((r) => r.setId) };
            const url = r[0].origin + interfaces_1.ApiRoutes.GET_AVG_PRICE;
            return { requests: r, url, params };
        });
    }
}
const GetTokenAvgPriceGroupedLive = new GetTokenAvgPriceGroupedLiveClass();
exports.default = GetTokenAvgPriceGroupedLive;
